export const CELL_HEIGHT = '70px' as const

export const COLUMN_SIZE = {
  ACTIONS: 100,
  EXPANDER: 70,
  STANDARD: 150,
  WIDER: 300,
} as const
